import React from 'react';
import { SEOHeader } from 'views/components';
const Dashboard = () => {
  return (
    <>
    <SEOHeader title="Dashboard"/>
     Welcome Dashboard
    </>
  );
};

export default Dashboard;
